<template>
    <section class="article">
        <div class="container">
            <div class="row">
                <div class="col-12 head">
                    <h2 class="title">{{ $t('why_you_should_know_your_genome.title') }}</h2>
                </div>
            </div>
            <div class="row text-justify">
                <div class="col-12 pb-4">
                    <img src="../assets/img/helix-info.jpg" alt="" style="max-width: 38%" class="float-img float-right w-100 p-0 pl-sm-3 pt-3 pt-sm-0 pb-3">
                    <div class="" v-html="$t('why_you_should_know_your_genome.section_1')"></div>
                    <div class="card-conatiner pt-3">
                                <div class="">
                                    <img src="../assets/img/plansza_01e-blue.png" alt="" class="float-img float-left w-100 p-0 pr-sm-4 pt-3 pt-sm-2 pb-3" style="max-width: 38%;">
                                </div>
                                <div class="">
                                    <div class="" v-html="$t('why_you_should_know_your_genome.section_1_extended')"></div>
                                </div>
                    </div>
                    <div class="pt-4" style="clear: both;" v-html="$t('why_you_should_know_your_genome.section_2')"></div>
                    <div class="" v-html="$t('why_you_should_know_your_genome.section_2_extended')"></div>
                </div>
                <div>
                    
                </div>
                <div class="col-12">
                    <h4 class="title">{{
                            $t('why_you_should_know_your_genome.what_is_included_in_the_genome_analysis_report')
                    }}</h4>
                    <img src="../assets/img/Medycyna_spersonalizowana_z_pudelkami_v3.jpg" alt="" style="max-width: 38%"  class="float-img float-left w-100 p-0 pr-sm-3 pt-3 pt-sm-0 pb-3">
                    <div class="" v-html="$t('why_you_should_know_your_genome.section_3')"></div>
                </div>

            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "WhyYouShouldKnowYourGenome",
    mounted:function(){
        this.scrolltohash()
    },
    methods:{
        scrolltohash:function(){
            const hash = document.getElementById(this.$route.hash.substring(1));
            if (hash != null) {
                const y = hash.getBoundingClientRect().top + window.pageYOffset + -80;
                hash.classList.add("focus-on");
                window.scrollTo({top: y, behavior: 'smooth', block: 'start'});
            }
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/WhyYouShouldKnowYourGenome.vue